import React from 'react';

import { WarnModal } from '@/components/elements';

interface Props {
  fullName?: string;
  onClose: () => void;
}

const ProvideFullAccessSuccessModal: React.FC<Props> = ({ fullName, onClose }) => (
  <WarnModal
    testId="provide-full-access-success"
    visible
    isSuccessIcon
    onSetVisible={onClose}
    header={`${fullName} was verified successfully!`}
    submitButtonText="Got it!"
    onSubmit={onClose}
  />
);

export default ProvideFullAccessSuccessModal;
